module.exports = __webpack_public_path__ + "img/logo.abfffa06.png";